import React from 'react';
import {useLocalization} from 'localization';
import type {ActionButtonV2Props} from './ActionButtonV2';
import {ActionButtonV2} from './ActionButtonV2';

export const CancelButton: React.FC<ActionButtonV2Props> = ({
  title,
  ...props
}) => {
  const {t} = useLocalization();
  const resolvedTitle = title ?? t('general.cancel');
  return (
    <ActionButtonV2 title={title} {...props} color={'primary'}>
      {resolvedTitle}
    </ActionButtonV2>
  );
};
